import fontawesome from "@fortawesome/fontawesome-free/js/all"
import "@fortawesome/fontawesome-free/css/all.css"

export default fontawesome;